import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Opens the Willy AI chat from anywhere in the app (e.g. "Diagnose this plant"
 * on the plant details page), optionally pre-filling the message input.
 * The app menu listens to open the modal; the chatbot listens for the prefill.
 */
@Injectable({ providedIn: 'root' })
export class WillyChatService {
  private readonly openChatSubject = new Subject<string | undefined>();
  openChat$ = this.openChatSubject.asObservable();

  openChat(prefillText?: string) {
    this.openChatSubject.next(prefillText);
  }
}
